<h3 class="_white">{{ titleKey() | translate }}</h3>

<kiwi-spacer [size]="8"></kiwi-spacer>

<ng-content></ng-content>

<div style="display: block;">
    <canvas baseChart
            [datasets]="datasets()"
            [labels]="barChartLabels()"
            [options]="barChartOptions()"
            [plugins]="barChartPlugins"
            [legend]="barChartLegend"
            [type]="barChartType">
    </canvas>
</div>
